import React, { useState } from "react";
import Modal from "src/components/common/Modal";
import AddMedicationModal from "./AddMedicationModal";
import Button from "../../Button";
import { ArrowLeftIcon, PlusIcon } from "lucide-react";
import MedicationList from "./MedicationList";

interface MedicationModalProps {
  show: boolean;
  handleClose: () => void;
}

const MedicationModal: React.FC<MedicationModalProps> = ({
  show,
  handleClose,
}) => {
  const [modalType, setModalType] = useState<"add" | "edit" | "list">("list");
  const [showAddMedicationModal, setShowAddMedicationModal] = useState(false);
  const [refreshMedicationList, setRefreshMedicationList] = useState(false);
  const [showEditMedicationModal, setShowEditMedicationModal] = useState(false);
  const [medication, setMedication] = useState<any>(null);

  // const modalClose = () => {
  //   setModalType("list");
  //   handleClose();
  // };

  if (!show) return null;

  return (
    <>
      <Modal
        show={show}
        showCloseButton
        handleClose={handleClose}
        title="Medication"
        // title={modalType === "list" ? "Medication" : "Add New Medication"}
        // showBackButton={modalType !== "list"}
        // backButton={
        //   <button onClick={() => setModalType("list")}>
        //     <ArrowLeftIcon className="w-4 h-4" />
        //   </button>
        // }
      >
        <div className="relative space-y-4">
          {/* {modalType === "edit" && (
          <div className="flex items-center gap-5">
            <h2 className="text-base font-medium">Edit Medication</h2>
          </div>
        )} */}
          <div className="w-full relative">
            <div className="rrelative w-full space-y-4">
              <div className="relative w-full">
                {/* {modalType === "list" && ( */}
                <Button
                  fullWidth
                  onClick={() => setShowAddMedicationModal(true)}
                >
                  <PlusIcon className="w-4 h-4 mr-2" /> Add New Medication
                </Button>
                {/* )} */}
              </div>
              <div className="relative w-full">
                <MedicationList
                  refresh={refreshMedicationList}
                  setShowEditMedicationModal={setShowEditMedicationModal}
                  setMedication={setMedication}
                />
              </div>
            </div>
            {/* <AddMedicationModal /> */}
          </div>
        </div>
      </Modal>

      {showAddMedicationModal && (
        <AddMedicationModal
          onSuccess={() => {
            setShowAddMedicationModal(false);
            setRefreshMedicationList(true);
            setTimeout(() => {
              setRefreshMedicationList(false);
            }, 600);
          }}
          handleClose={() => setShowAddMedicationModal(false)}
        />
      )}

      {showEditMedicationModal && (
        <AddMedicationModal
          onSuccess={() => {
            setShowEditMedicationModal(false);
          }}
          handleClose={() => setShowEditMedicationModal(false)}
          isEdit={true}
          medicationData={medication}
        />
      )}
    </>
  );
};

export default MedicationModal;
